import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-04/lesson-03/task-01";

const task: Slide = {
  descriptionHtml:
    "The vibration behaviour of the moving parts of a loudspeaker (diaphragm, coil, suspension and spider) can be<br /> considered similar to that of a damped mechanical oscillator.  Calculate its natural frequency knowing that we have<br /> here M<sub>m</sub>= 20 g, C<sub>m</sub>=1.4 mm/N and R<sub>m</sub> = 0.59 kg/s.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/03/task/task-1-item-1.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
